import React from 'react';
import { Dropdown, Avatar, Modal, Upload, Form, Input, InputNumber, Switch, Button, message } from 'antd';
import { PlusOutlined, InboxOutlined } from '@ant-design/icons';
import axios from 'axios';
import { MenuFoldOutlined, MenuUnfoldOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';
import './index.css';

const Header = ({ collapsed, onToggle }) => {
  const { user, logout } = useAuth();

  // 在组件内部 state（比如组件函数最前面）
  const [bannerModalOpen, setBannerModalOpen] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [fileList, setFileList] = React.useState([]);
  const [form] = Form.useForm();

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
    },
    {
      key: 'settings',
      icon: <UserOutlined />,
      label: '轮播图设置',
      onClick: () => setBannerModalOpen(true)
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <UserOutlined />,
      label: '退出登录',
      danger: true,
    },
  ];

  const handleUserMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
    }
  };

  const getRoleText = (role) => {
    const roleMap = {
      admin: '管理员',
      master: '师傅',
      service: '客服'
    };
    return roleMap[role] || role;
  };


  // 组件内部函数
  const handleBulkUpload = async () => {
    try {
      const values = await form.validateFields();
      if (!fileList.length) {
        message.warning('请先选择图片');
        return;
      }
      const fd = new FormData();
      fileList.forEach(f => fd.append('images', f.originFileObj));

      // 统一字段（也可扩展为逐张图的 titles/link_urls/sort_orders）
      if (values.title) fd.append('titles', values.title);   // 后端允许多值，这里示例用统一标题
      if (values.link_url) fd.append('link_urls', values.link_url);
      if (values.sort_order !== undefined) fd.append('sort_orders', String(values.sort_order));
      fd.append('is_show', values.is_show ? 'true' : 'false');

      setUploading(true);
      await axios.post('/api/banners/bulk_upload', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      message.success('上传成功');
      setBannerModalOpen(false);
      setFileList([]);
      form.resetFields();
    } catch (e) {
      if (e?.errorFields) return; // 表单校验错误
      message.error('上传失败');
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      setUploading(false);
    }
  };



  return (
    <>
      <header className="app-header">
        <div className="header-left">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={onToggle}
            className="menu-toggle"
          />
        </div>

        <div className="header-right">
          <div className="user-info">
            <span className="welcome-text">
              欢迎，<span className="username">{user?.username}</span>
            </span>
            <span className="user-role">({getRoleText(user?.role)})</span>
          </div>

          <Dropdown
            menu={{
              items: userMenuItems,
              onClick: handleUserMenuClick,
            }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Avatar
              className="user-avatar"
              icon={<UserOutlined />}
            />
          </Dropdown>
        </div>
      </header>

      <Modal
        title="轮播图设置"
        open={bannerModalOpen}
        onCancel={() => setBannerModalOpen(false)}
        onOk={handleBulkUpload}
        confirmLoading={uploading}
        okText="上传并保存"
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="选择图片（可多选）"
            required
            tooltip="支持拖拽或点击选择，提交后将批量入库"
          >
            <Upload.Dragger
              multiple
              fileList={fileList}
              beforeUpload={() => false} // 不自动上传
              onChange={({ fileList }) => setFileList(fileList)}
              accept="image/*"
            >
              <p className="ant-upload-drag-icon"><InboxOutlined /></p>
              <p className="ant-upload-text">点击或拖拽图片到此处</p>
              <p className="ant-upload-hint">支持批量，大小以服务器限制为准</p>
            </Upload.Dragger>
          </Form.Item>
        </Form>
      </Modal>

    </>
  );
};

export default Header;
